<alert type="success" *ngFor="let success of successes">
  {{success | translate}}
</alert>
<alert type="danger" *ngFor="let error of errors">
  {{error | translate}}
</alert>